/**
 * Format the resource content by replacing the placeholders with data
 * @param content
 * @param params
 */
export function formatResource(
  content: string,
  params: Record<string, string>,
): string {
  let result = content;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value ?? '');
  });

  result = result.replace(/{{[^{}]+}}/g, '');
  return result;
}
